<!-- Page Header -->
<div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 2%;">
  <app-page-header title="Token Information" subtitle="JWT Token und Benutzerinformationen" icon="security"
    variant="gradient">
  </app-page-header>

  <button class="nlc-refresh-button" (click)="refreshTokenInfo()">
    <mat-icon>refresh</mat-icon>
  </button>
</div>

<div class="nlc-container nlc-slide-up">
  <!-- Not Authenticated State -->
  <div *ngIf="!isAuthenticated" class="nlc-card not-authenticated-card">
    <div class="empty-state">
      <div class="empty-icon-wrapper">
        <mat-icon class="empty-icon">lock</mat-icon>
      </div>
      <h3 class="nlc-heading-3">Nicht angemeldet</h3>
      <p class="nlc-body-secondary">Bitte melden Sie sich an, um Token-Informationen anzuzeigen.</p>
    </div>
  </div>

  <!-- Authenticated Content -->
  <div *ngIf="isAuthenticated && currentUser as cu" class="token-sections">

    <!-- User Information Card -->
    <div class="nlc-card info-section">
      <div class="section-header">
        <mat-icon class="section-icon">person</mat-icon>
        <h2 class="nlc-heading-3">Benutzerinformationen</h2>
      </div>
      <div class="info-content">
        <div class="info-grid">
          <div class="info-item">
            <label>User ID:</label>
            <span>{{ cu.id }}</span>
            <button mat-icon-button (click)="copyToClipboard(cu.id, 'User ID')" matTooltip="Copy to clipboard">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div class="info-item">
            <label>Email:</label>
            <span>{{ cu.email }}</span>
            <button mat-icon-button (click)="copyToClipboard(cu.email, 'Email')" matTooltip="Copy to clipboard">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div class="info-item">
            <label>Name:</label>
            <span>{{ cu.firstName }} {{ cu.lastName }}</span>
          </div>
          <div class="info-item">
            <label>User Type:</label>
            <mat-chip [color]="cu.userType === userTypeEnum.EMPLOYEE ? 'accent' : 'primary'">
              {{ cu.userType }}
            </mat-chip>
          </div>
          <div class="info-item">
            <label>Auth Method:</label>
            <mat-chip color="primary">{{ cu.authMethod }}</mat-chip>
          </div>
        </div>
      </div>
    </div>

    <!-- Session Identity -->
    <div class="nlc-card info-section" *ngIf="tokenInfo.account">
      <div class="section-header">
        <mat-icon class="section-icon">account_circle</mat-icon>
        <h2 class="nlc-heading-3">Session Identity</h2>
      </div>
      <div class="info-content">
        <div class="info-grid">
          <div class="info-item">
            <label>Name:</label>
            <span>{{ tokenInfo.account.name }}</span>
          </div>
          <div class="info-item">
            <label>Email:</label>
            <span>{{ tokenInfo.account.email }}</span>
            <button mat-icon-button (click)="copyToClipboard(tokenInfo.account.email || '', 'Email')"
              matTooltip="Copy to clipboard">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div class="info-item" *ngIf="tokenInfo.account.givenName">
            <label>Given Name:</label>
            <span>{{ tokenInfo.account.givenName }}</span>
          </div>
          <div class="info-item" *ngIf="tokenInfo.account.familyName">
            <label>Family Name:</label>
            <span>{{ tokenInfo.account.familyName }}</span>
          </div>
          <div class="info-item">
            <label>User Type:</label>
            <mat-chip [color]="cu.userType === userTypeEnum.EMPLOYEE ? 'accent' : 'primary'">
              {{ cu.userType }}
            </mat-chip>
          </div>
        </div>
      </div>
    </div>

    <!-- Customer Profile (CIAM) -->
    <div class="nlc-card info-section" *ngIf="tokenInfo.customerProfile">
      <div class="section-header">
        <mat-icon class="section-icon">badge</mat-icon>
        <h2 class="nlc-heading-3">Customer Profile</h2>
      </div>
      <div class="info-content">
        <div class="info-grid">
          <div class="info-item"><label>Id:</label><span>{{ tokenInfo.customerProfile.id }}</span></div>
          <div class="info-item"><label>Active:</label><span>{{ tokenInfo.customerProfile.isActive }}</span></div>
          <div class="info-item"><label>Registration Status:</label><span>{{
              tokenInfo.customerProfile.registrationStatus }}</span></div>
          <div class="info-item"><label>Coins (Total):</label><span>{{ tokenInfo.customerProfile.coinsTotal }}</span>
          </div>
          <div class="info-item"><label>Coins (Current):</label><span>{{ tokenInfo.customerProfile.coinsCurrent
              }}</span></div>
        </div>
      </div>
    </div>

    <!-- Token Information -->
    <div class="nlc-card info-section">
      <div class="section-header">
        <mat-icon class="section-icon">vpn_key</mat-icon>
        <h2 class="nlc-heading-3">Token Details</h2>
      </div>
      <div class="info-content">
        <div class="info-grid">
          <div class="info-item" *ngIf="tokenInfo.accessToken">
            <label>Access Token:</label>
            <span class="token-preview">{{ tokenInfo.accessToken }}</span>
            <button mat-icon-button (click)="copyToClipboard(tokenInfo.accessToken || '', 'Access Token')"
              matTooltip="Copy to clipboard">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div class="info-item" *ngIf="tokenInfo.idToken">
            <label>ID Token:</label>
            <span class="token-preview">{{ tokenInfo.idToken }}</span>
            <button mat-icon-button (click)="copyToClipboard(tokenInfo.idToken || '', 'ID Token')"
              matTooltip="Copy to clipboard">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div class="info-item" *ngIf="tokenInfo.expiresOn">
            <label>Expires On:</label>
            <span>{{ formatDate(tokenInfo.expiresOn) }}</span>
          </div>
          <div class="info-item" *ngIf="tokenInfo.scopes && tokenInfo.scopes.length > 0">
            <label>Scopes:</label>
            <div class="chip-list">
              <mat-chip *ngFor="let scope of tokenInfo.scopes">{{ scope }}</mat-chip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Groups and Roles -->
    <div class="nlc-card info-section">
      <div class="section-header">
        <mat-icon class="section-icon">group</mat-icon>
        <h2 class="nlc-heading-3">Groups and Roles</h2>
      </div>
      <div class="info-content">
        <div class="roles-section">
          <div class="section">
            <h4>Azure AD Groups</h4>
            <div class="chip-list" *ngIf="tokenInfo.groups && tokenInfo.groups.length > 0; else noGroups">
              <mat-chip *ngFor="let group of tokenInfo.groups" color="accent">{{ group }}</mat-chip>
            </div>
            <ng-template #noGroups>
              <p class="no-data">No groups assigned</p>
            </ng-template>
          </div>

          <mat-divider></mat-divider>

          <div class="section">
            <h4>Application Roles</h4>
            <div class="chip-list" *ngIf="tokenInfo.roles && tokenInfo.roles.length > 0; else noRoles">
              <mat-chip *ngFor="let role of tokenInfo.roles" color="primary">
                {{ getRoleDisplayName(role) }}
              </mat-chip>
            </div>
            <ng-template #noRoles>
              <p class="no-data">No roles assigned</p>
            </ng-template>
          </div>

          <mat-divider></mat-divider>

          <div class="section">
            <h4>Permissions</h4>
            <div class="permissions-grid"
              *ngIf="tokenInfo.permissions && tokenInfo.permissions.length > 0; else noPermissions">
              <mat-chip *ngFor="let permission of tokenInfo.permissions" color="warn">
                {{ getPermissionDisplayName(permission) }}
              </mat-chip>
            </div>
            <ng-template #noPermissions>
              <p class="no-data">No permissions assigned</p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- Token Claims (Expandable) -->
    <div class="nlc-card info-section" *ngIf="tokenInfo.claims && tokenInfo.claims.length > 0">
      <div class="section-header">
        <mat-icon class="section-icon">code</mat-icon>
        <h2 class="nlc-heading-3">Token Claims (Raw)</h2>
      </div>
      <div class="info-content">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>View Raw Token Claims</mat-panel-title>
            <mat-panel-description>
              Technical details from the JWT token
            </mat-panel-description>
          </mat-expansion-panel-header>
          <pre class="json-display">{{ tokenInfo.claims | json }}</pre>
          <div class="copy-button-container">
            <button mat-flat-button
              (click)="copyToClipboard(JSON.stringify(tokenInfo.claims, null, 2), 'Token Claims')">
              <mat-icon>content_copy</mat-icon>
              Copy Claims JSON
            </button>
          </div>
        </mat-expansion-panel>
      </div>
    </div>

  </div>
</div>